<ng-template #loading>
  <app-mat-spinner-overlay text="Vent litt..."></app-mat-spinner-overlay>
</ng-template>

<div *ngIf="data; else loading" class="flex-colum flex-gap-20">

  <h1>{{getLabelValue('FeedbackTitle') | striphtml}}</h1>

  <p *ngIf="getLabelValue('FeedbackHelpText')" [innerHtml]="getLabelValue('FeedbackHelpText') | safe: 'html'"></p>

  <div class="flex-row flex-gap-20">

    <div class="flex-center">
      <mat-icon (click)="toggle(1)" (mouseenter)="toggleHover(1)" (mouseleave)="toggleHover(1)"
        [ngClass]="{selected: selected === 1}" class="big-icon green-icon click" fontSet="material-icons-outlined">
        <span *ngIf="selected !== 1">sentiment_satisfied</span>
        <span *ngIf="selected === 1">sentiment_very_satisfied</span>
      </mat-icon>
    </div>

    <div class="flex-center">
      <mat-icon (click)="toggle(2)" (mouseenter)="toggleHover(2)" (mouseleave)="toggleHover(2)"
        [ngClass]="{selected: selected === 2}" class="big-icon yellow-icon click" fontSet="material-icons-outlined">
        sentiment_neutral
      </mat-icon>
    </div>

    <div class="flex-center">
      <mat-icon (click)="toggle(3)" (mouseenter)="toggleHover(3)" (mouseleave)="toggleHover(3)"
        [ngClass]="{selected: selected === 3}" class="big-icon red-icon click" fontSet="material-icons-outlined">
        <span *ngIf="selected !== 3">sentiment_dissatisfied</span>
        <span *ngIf="selected === 3">sentiment_very_dissatisfied</span>
      </mat-icon>
    </div>

  </div>

  <div class="flex-column flex-gap-20">

    <!-- <h2>Tilbakemelding</h2> -->

    <p [innerHtml]="getLabelValue('FeedbackContent') | safe: 'html'"></p>

    <mat-form-field>
      <mat-label>Tilbakemelding</mat-label>
      <textarea #messageInput matInput rows="6" [(ngModel)]="message" maxlength="2000"></textarea>
      <mat-hint align="end">{{messageInput.value.length || 0}} av 2000 tegn</mat-hint>
    </mat-form-field>

    <div>
      <button *ngIf="!loggedIn" type="button" mat-raised-button class="finkn-btn" (click)="submit()"
        color="primary">
        <span>Avslutt og gå til forside</span>
      </button>

      <button *ngIf="loggedIn && caseUId" type="button" mat-raised-button class="finkn-btn" (click)="submit()"
        color="primary">
        <span>Avslutt og gå til Min sak</span>
      </button>
    </div>

  </div>

</div>